// Embed-mode support for running inside the SuperProcure main app as an iframe.
// The main app appends token, is_embed, freighterId and tripId to the iframe src.
// The token is held in module memory only - it must never reach storage, logs
// or the DOM.

let embedState = {
  isEmbed: false,
  token: null,
  freighterId: null,
  tripId: null,
};

const EMBED_PARAMS = ['token', 'is_embed', 'freighterId', 'tripId'];

// Reads the embed params once at boot and strips them from the visible URL.
// Must run before the app renders so the token never lingers in the URL.
export function initEmbedState() {
  const searchParams = new URLSearchParams(window.location.search);

  // The app uses hash routing, so also accept params appended after the
  // route (e.g. /#/verify-vahan?is_embed=true&token=...).
  const hash = window.location.hash || '';
  const hashQueryIndex = hash.indexOf('?');
  const hashPath = hashQueryIndex >= 0 ? hash.slice(0, hashQueryIndex) : hash;
  const hashParams = new URLSearchParams(
    hashQueryIndex >= 0 ? hash.slice(hashQueryIndex + 1) : '',
  );

  const pick = (name) => searchParams.get(name) || hashParams.get(name);

  if (pick('is_embed') !== 'true') {
    return;
  }

  embedState = {
    isEmbed: true,
    token: pick('token') || null,
    freighterId: pick('freighterId') || null,
    tripId: pick('tripId') || null,
  };

  EMBED_PARAMS.forEach((name) => {
    searchParams.delete(name);
    hashParams.delete(name);
  });

  const search = searchParams.toString();
  const hashQuery = hashParams.toString();
  const cleanedUrl =
    window.location.pathname +
    (search ? '?' + search : '') +
    hashPath +
    (hashQuery ? '?' + hashQuery : '');
  window.history.replaceState(null, document.title, cleanedUrl);
}

export function isEmbedded() {
  return embedState.isEmbed;
}

export function getEmbedToken() {
  return embedState.token;
}

export function getEmbedTripContext() {
  return {
    freighterId: embedState.freighterId,
    tripId: embedState.tripId,
  };
}

export function hasEmbedTripContext() {
  return Boolean(embedState.freighterId && embedState.tripId);
}
